import {
  IMiniStressScoringPayload,
  ActionType,
  IMiniStressScoringResponse,
} from "models/stressCheck/miniStressScoringInformation";

export const getMiniStressScoringAction = (
  payload: IMiniStressScoringPayload
) => {
  return {
    type: ActionType.MINI_STRESS_SCORING,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.MINI_STRESS_SCORING_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IMiniStressScoringResponse) => {
  return {
    type: ActionType.MINI_STRESS_SCORING_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.MINI_STRESS_SCORING_RESET,
  };
};
